module.exports = __webpack_public_path__ + "media/images/logo_gobpe-76c198fd5094982acbd8dca72d9fd52f.svg";